










































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Form, Message, MessageBox } from 'element-ui'
import TableForm from '@/components/common/TableForm.vue'
import SearchForm from '@/components/common/SearchForm.vue'
import $Api from '@api'
import { TallyBillApproveRecord, RepaymentState, TallyBillState, TallyBillType, RepaymentPageRecord } from '@/api/model/repayment'
import { translate, DateTime } from '@/utils/filters'
import { finalize } from 'rxjs/operators'
import ManualForm from '@/views/subject/repayment/unpaid/form/ManualForm.vue'
import PartialForm from '@/views/subject/repayment/unpaid/form/PartialForm.vue'
import SettlementForm from '@/views/subject/repayment/unpaid/form/SettlementForm.vue'
import store from '@/store'
import RepamentImgDialog from '@/views/subject/repayment/tallybill/RepamentImg.vue'

@Component({
    components: {
        SearchForm,
        TableForm,
        ManualForm,
        PartialForm,
        SettlementForm,
        RepamentImgDialog
    }
})
export default class extends Vue {
    StatusOption: { label: string; value: TallyBillState }[] = [
        {
            label: translate('repayment.tallyBillState.waitApprove'),
            value: TallyBillState.WAIT_APPROVE
        },
        {
            label: translate('repayment.tallyBillState.finishApprove'),
            value: TallyBillState.FINISH_APPROVE
        },
        {
            label: translate('repayment.tallyBillState.cancelApprove'),
            value: TallyBillState.CANCEL_APPROVE
        }
    ]

    TallyBillTypeOptions: { label: string; value: TallyBillType }[] = [
        {
            label: translate('repayment.tallyBillType.inbursaRepay'),
            value: TallyBillType.INBURSA_REPAYMENT
        },
        {
            label: translate('repayment.tallyBillType.overdueRepay'),
            value: TallyBillType.OVERDUE_REPAYMENT
        }
    ]
    cacheData = {};
    partialFormVisible = false
    manualFormVisible = false
    settlementFormVisible = false
    tableData: TallyBillApproveRecord[] = []
    shouldTableLoading = false
    total = 0
    show = false
    shouldTimeDateValue = null
    dateTime = DateTime
    defaultTime = ['00:00:00', '23:59:59']

    searchForm: { [key: string]: any } = {
        current: 1,
        size: 10,
        bizId: null,
        status: null,
        tallyBillType: null
    }

    created(): void {
        this.getData()
    }
    handleClose(val: boolean) {
        this.show = false
    }

    viewRepaymentVoucher(row: TallyBillApproveRecord): void{
        if (row.repaymentVoucher === null || row.repaymentVoucher === '') {
            Message.error(translate('repayment.hx.noVoucherUpload') as string)
            return
        }
        this.show = true
        this.cacheData = row
    }

    getData(pageQuery?: object): void {
        if (pageQuery) {
            Object.assign(this.searchForm, pageQuery)
        }
        this.shouldTableLoading = true
        const formData = this.clearEmptyProperty(this.searchForm)
        $Api.repaymentService
            .tallyBillAproveRecordPage(formData)
            .pipe(
                finalize(() => {
                    this.shouldTableLoading = false
                })
            )
            .subscribe(res => {
                this.tableData = res.records
                this.total = res.total
            })
    }
    // 手动核销
    tallyBillOperate(row: TallyBillApproveRecord) :void{
        if (row.status !== 1) { // 待审核状态才可以核销。
            Message.error(translate('repayment.hx.stateNotSupportOperation') as string)
            return
        }
        this.manualFormVisible = true
        this.$nextTick(() => {
            ;(this.$refs['manualForm'] as any).fetchDataByTallyBill(row)
        })
        this.getData()
    }
    // 部分还款
    partialRepamentOperate(row: TallyBillApproveRecord) :void{
        if (row.status !== 1) { // 待审核状态才可以核销。
            Message.error(translate('repayment.hx.stateNotSupportOperation') as string)
            return
        }
        this.partialFormVisible = true
        this.$nextTick(() => {
            ;(this.$refs['partialForm'] as any).fetchDataByTallyBill(row)
        })
        this.getData()
    }
    // 正常结清
    settlementOperate(row: TallyBillApproveRecord) :void{
        if (row.status !== 1) { // 待审核状态才可以核销。
            Message.error(translate('repayment.hx.stateNotSupportOperation') as string)
            return
        }
        this.settlementFormVisible = true
        this.$nextTick(() => {
            ;(this.$refs['settlementForm'] as any).fetchDataByTallyBill(row)
        })
        this.getData()
    }
    // 取消
    tallyBillCall(row: TallyBillApproveRecord) :void{
        if (row.status !== 1) { // 待审核状态才可以核销。
            Message.error(translate('repayment.hx.stateNotSupportOperation') as string)
            return
        }
        MessageBox.confirm(
            translate('repayment.hx.sureCancel'),
            translate('common.tip'),
            {
                confirmButtonText: translate('common.btn.confirm'),
                cancelButtonText: translate('common.btn.cancel')
            }
        ).then(() => {
            const updateUser = store && store.state.auth.authInfo.userId
            const updateUserName = store && store.state.auth.authInfo.displayName
            row.updateUser = updateUser
            row.updateUserName = updateUserName
            $Api.repaymentService.cancelTallyBill(row).subscribe(
                data => {
                    if (data) {
                        Message.success(translate('repayment.hx.cancelSuccess'))
                        this.getData()
                    } else {
                        Message.success(translate('repayment.hx.cancelFailed'))
                    }
                },
                error => {
                    Message.error(error.message)
                })
        }).catch(() => {})
        // 取消操作
    }

    onSearchSubmit(): void {
        this.searchForm.current = 1
        this.getData()
    }

    onFormReset(): void {
        // The resetFields method (from SearchForm.vue) does not take effect on datePicker, need to reset manually
        this.shouldTimeDateValue = null
    }

    viewLoanDetail(row: TallyBillApproveRecord): void {
        const query = {
        }
        this.$router.push({ path: '/repayment/unpaid/detail', query })
    }

    clearEmptyProperty(source: any): any {
        const cloneSource = Object.assign({}, source)
        Object.keys(cloneSource).forEach(key => {
            if (cloneSource[key] === '' || cloneSource[key] === null) {
                delete cloneSource[key]
            }
        })
        return cloneSource
    }

    reset(formName: string): void {
        ;(this.$refs[formName] as Form).resetFields()
    }

    @Watch('shouldTimeDateValue')
    onShouldTimeDateValueChange(date: [Date, Date]): void {
        if (!date) {
            this.searchForm.shouldTimeBegin = null
            this.searchForm.shouldTimeEnd = null
        } else {
            const [shouldTimeBegin, shouldTimeEnd] = date
            this.searchForm.shouldTimeBegin = shouldTimeBegin.getTime()
            this.searchForm.shouldTimeEnd = shouldTimeEnd.getTime()
        }
    }
}
